<div class="h-screen min-h-screen max-h-screen max-w-screen min-w-screen w-screen bg-gray-100 overflow-hidden flex flex-col justify-center items-start">
  <div
    class="px-4 h-[10vh] py-2 w-screen flex flex-row font-medium shadow-gray-300 shadow-2xl justify-between items-center text-white bg-gradient-blue mb-0"
  >
    @if (showBack()) {
    <div (click)="back()">Regresar</div>
    }

    <div
      [ngClass]="{ 'justify-end pt-4': showBack, 'justify-start': !showBack }"
      class="w-full h-full flex items-center"
    ></div>
    <div
      class="h-[10vh] w-full flex flex-row items-center justify-end p-0 float-right"
    >
      <img
        src="svg/logo-blanco.svg"
        class="h-[50px] float-right"
        alt="Logo Fincomercio"
      />
    </div>
  </div>

  <div class="w-screen flex items-center justify-end py-0 !bg-transparent">
    <label
      class="text-white h-5 text-[10px] text-center px-2 bg-gradient-to-b from-[#003aa2] to-[#0075ff] rounded-b-2xl"
      for="consultor"
    >
      <b>Tu asesor:</b> {{ consultor()?.name | titlecase }}
    </label>
  </div>
  <div class="max-w-screen min-w-screen w-screen overflow-hidden h-full pt-2 pb-0 px-5 text-black">
    <router-outlet />
  </div>
</div>
